import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { apiService } from '../services';
import { PaymentPageOpts } from '../helpers/payments';

class CreditGuardPaymentCallback extends React.Component {
  componentDidMount() {
    this.makeRequest();
  }

  makeRequest() {
    const {
      location: { search },
      processCreditGuardPublicPaymentAPI
    } = this.props;

    const qryObject = new URLSearchParams(search);
    const status = qryObject.get('status');
    const page = qryObject.get('page');
    if (!PaymentPageOpts[page]) {
      console.error(`Invalid page ${page}`);
      this.emitMessage({ status: 'error', page, res: { message: 'Unable to make payment request' } });
      return;
    }

    if (!status) {
      this.emitMessage({ status: 'error', page, res: { message: 'Unable to make payment request' } });
      return;
    }

    const vals = {};
    qryObject.forEach((v, k) => {
      vals[k] = v;
    });

    const apiCall = processCreditGuardPublicPaymentAPI;

    return apiService
      .callServer(
        apiCall,
        { ':status:': status },
        null,
        JSON.stringify(vals),
        null,
        true
      )
      .then(res => {
        this.emitMessage({ status, page, res });
      })
      .catch(err => {
        console.error('Error on credit guard callback', page, err);
        this.emitMessage({ status: 'error', page, res: { err } });
      });
  }

  /*
    Note: alternative solution is possible:

    window.parent.history.pushState({ ...res }, page, `/${page}/callback/${status}`);

    const someIframe = window.parent.document.getElementById('iframe_callback');
    someIframe.parentNode.removeChild(window.parent.document.getElementById('iframe_callback'));
  */
  emitMessage(args) {
    window.parent.postMessage(args);
    window.close();
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  const { processCreditGuardPublicPayment } = state.api;
  return {
    processCreditGuardPublicPaymentAPI: processCreditGuardPublicPayment
  };
}

export default connect(mapStateToProps)(withRouter(CreditGuardPaymentCallback));
